<template>
    <div id="app" style="position: relative;">
        <div class="printer-container" style="width: 100vw; background: #ebecf1; position: absolute; top: 0; left: 0; z-index: 100000;">
            <div style="width: 1300px; margin: 0 auto;">
                <page size="A4" style="margin: 0 auto;">
                    <portal-target name="destination"></portal-target>
                </page>
            </div>
        </div>
        <notifications/>

        <fade-transition :duration="200" mode="out-in">
            <router-view class="no-print"/>
        </fade-transition>
    </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions'
import { mapState } from 'vuex'

export default {
    components: {
        FadeTransition
    },
    computed: {
        ...mapState([
            'event',
            'user',
        ])
    },
    data () {
        return {
            timer: null
        }
    },
    async mounted () {
        await this.getSettings()
        window.onresize = () => {
            this.onResize()
        }
        this.onResize()
        
        this.restartInactivityTimer()
        
        document.addEventListener('click', () => {
            this.restartInactivityTimer()
        })
        
        window.addEventListener('scroll', () => {
            this.restartInactivityTimer()
        })

    },
    watch: {
        event(nv){
            this.restartInactivityTimer(parseInt(nv.authTimeout) * 1000)
        }
    },
    methods: {
        getSettings: async function () {
            try {
                await this.$store.dispatch('get', { path: 'settings', key: 'settings', id: '' })
            } catch (e) {
                console.log(e)
                // console.log('error getting settings')
            }
        },
        onResize: function () {
            this.$store.commit('SET_PROPS', ['width', window.innerWidth])
            this.$store.commit('SET_PROPS', ['isMobile', window.innerWidth < 768])
        },
        restartInactivityTimer: function (time = 1800 * 1000 ) {  
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                if (this.user._id) {
                    this.$store.dispatch('logout')
                    this.$notify({ type: 'danger', message: 'Session expired!' })
                    this.$router.push({ name: 'login' })
                }
            }, time) // 30 minutes
        },
    }
}
</script>

<style lang="sass" src="./assets/css/main.sass"/>
<style>

@media print {
    page[size="A4"] {
      background: white;
      width: 21cm;
      height: 29.7cm;
      display: block;
      margin: 0 auto;
      margin-bottom: 0.5cm;
      box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
    }
    body, page[size="A4"] {
        margin: 0;
        box-shadow: 0;
    }

    .no-print{
        display: none;
    }
}
</style>
